import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Create Overtime
export const createOvertime = createAsyncThunk(
  'overtime/create',
  async (overtimeData: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/overtime', overtimeData);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create overtime');
    }
  }
);

// Update Overtime
export const updateOvertime = createAsyncThunk(
  'overtime/update',
  async ({ overtimeId, data }: { overtimeId: number; data: any}, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/overtime/${overtimeId}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update overtime');
    }
  }
);

// Delete Overtime
export const deleteOvertime = createAsyncThunk(
  'overtime/delete',
  async (overtimeId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/overtime/${overtimeId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete overtime');
    }
  }
);

// Fetch Overtime by ID
export const fetchOvertimeById = createAsyncThunk(
  'overtime/fetchById',
  async (overtimeId: number, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/overtime/${overtimeId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch overtime entry');
    }
  }
);


export const fetchOvertimeByEmployeeId = createAsyncThunk(
  'overtime/fetchOvertimeByEmployeeId',
  async (employeeId: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/overtime/employeeId/${employeeId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch overtime entry');
    }
  }
);


export const fetchOvertimeSummaryByEmployeeId = createAsyncThunk(
  'overtime/fetchOvertimeSummaryByEmployeeId',
  async (employeeId: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/overtime/employeeIdsummary/${employeeId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch overtime entry');
    }
  }
);

// Fetch All Overtimes
export const fetchAllOvertimes = createAsyncThunk(
  'overtime/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/overtime');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch all overtime entries');
    }
  }
);
// Fetch All Summary
export const fetchOvertimeSummary = createAsyncThunk(
  'overtime/OvertimeSummary',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/overtime-details');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch all overtime entries');
    }
  }
);

// Fetch Overtime for Supervisor Hierarchy
export const fetchOvertimeBySupervisorHierarchy = createAsyncThunk(
  'overtime/fetchOvertimeBySupervisorHierarchy',
  async (
    { supervisorId, includeSelf = false }: { supervisorId: number; includeSelf?: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await employeeServiceApiInstance.get(
        `/overtime/supervisor/${supervisorId}`,
        { params: { includeSelf } }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch supervisor hierarchy overtime');
    }
  }
);

// Fetch Overtime Summary for Supervisor Hierarchy
export const fetchOvertimeSummaryBySupervisorHierarchy = createAsyncThunk(
  'overtime/fetchOvertimeSummaryBySupervisorHierarchy',
  async (
    { supervisorId, includeSelf = false }: { supervisorId: number; includeSelf?: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await employeeServiceApiInstance.get(
        `/overtime/supervisor/${supervisorId}/summary`,
        { params: { includeSelf } }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch supervisor hierarchy overtime summary');
    }
  }
);

